import { ListSaved } from '@/features/List/list';
import { User } from '@/features/User/User';

type Notification = {
	id: number;
	title: string;
	body: string;
	date: Date;
};

const messagesUser = {
	now: {
		fr: {
			title: `C'est votre anniversaire aujourd'hui!`,
			body: `Joyeux anniversaire!`,
		},
		en: {
			title: `It's your birthday today!`,
			body: `Happy birthday!`,
		},
	},
	month: {
		fr: {
			title: `C'est votre anniversaire dans un mois!`,
			body: `Pensez à remplir votre liste de souhaits!`,
		},
		en: {
			title: `It's your birthday in a month!`,
			body: `Think about filling your wish list!`,
		},
	},
};

export const setNotifications = (
	lists: ListSaved[],
	user: User,
	lang: 'fr' | 'en'
) => {
	const messagesLists = {
		now: {
			fr: {
				title: `C'est l'anniversaire de {{name}} aujourd'hui! `,
				body: `Souhaitez-lui un joyeux anniversaire!`,
			},
			en: {
				title: `It's {{name}}'s birthday today! `,
				body: `Wish them a happy birthday!`,
			},
		},
		month: {
			fr: {
				title: `C'est l'anniversaire de {{name}} dans un mois ! `,
				body: `Pensez à lui réserver un cadeau!`,
			},
			en: {
				title: `It's {{name}}'s birthday in a month! `,
				body: `Think about getting them a gift!`,
			},
		},
	};
	const notifications: Notification[] = [];

	lists.forEach((list) => {
		if (notifications.find((n) => n.id === list.user.id)) return;
		const today = new Date();
		const notificationDate = new Date(list.user.birthday as string);
		notificationDate.setFullYear(today.getFullYear());
		if (today.getTime() > notificationDate.getTime()) {
			notificationDate.setFullYear(today.getFullYear() + 1);
		}
		notifications.push({
			id: list.user.id,
			title: 'Giftee',
			body:
				messagesLists.now[lang].title.replace(
					'{{name}}',
					list.user.firstname
				) + messagesLists.now[lang].body,
			date: notificationDate,
		});

		const monthFromNow = new Date(list.user.birthday as string);
		monthFromNow.setMonth(monthFromNow.getMonth() - 1);
		monthFromNow.setFullYear(today.getFullYear());
		if (today.getTime() > monthFromNow.getTime()) {
			monthFromNow.setFullYear(today.getFullYear() + 1);
		}

		notifications.push({
			id: list.user.id,
			title: messagesLists.month[lang].title.replace(
				'{{name}}',
				list.user.firstname
			),
			body: messagesLists.month[lang].body,
			date: monthFromNow,
		});
	});

	const today = new Date();
	const notificationDate = new Date(user.birthday as string);
	notificationDate.setFullYear(today.getFullYear());
	if (today.getTime() > notificationDate.getTime()) {
		notificationDate.setFullYear(today.getFullYear() + 1);
	}
	notifications.push({
		id: user.id,
		title: messagesUser.now[lang].title,
		body: messagesUser.now[lang].body,
		date: notificationDate,
	});

	const monthFromNow = new Date(user.birthday as string);
	monthFromNow.setMonth(monthFromNow.getMonth() - 1);
	monthFromNow.setFullYear(today.getFullYear());
	if (today.getTime() > monthFromNow.getTime()) {
		monthFromNow.setFullYear(today.getFullYear() + 1);
	}
	notifications.push({
		id: user.id,
		title: messagesUser.month[lang].title,
		body: messagesUser.month[lang].body,
		date: monthFromNow,
	});

	return notifications;
};
